import { KeywordKeywords } from "@/features/keyword-monitoring/components/forms";

export default function SourceKeyword() {
  return (
    <div>
      <KeywordKeywords />
    </div>
  );
}
